export enum MarkerTag {
  DotWorstSlot = 'dot-worst-slot',
  DotSlotBbq = 'dot-slot-bbq',
  StatusBackground = 'status-background',
  WhiteSlate = 'white-slate',
  CoastalBlue = 'coastal-blue',
  Tides = 'tides',
  MtnTrack = 'mtn-track',
  WeatherStationTemp = 'WS-TEMP',
  WeatherStationRainfall = 'WS-RAINFALL',
  WeatherStationSoilMoisture = 'WS-SOIL-MOISTURE',
  WeatherStationSoilTemp = 'WS-SOIL-TEMP',
}
